import React, { createContext, useContext, useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import { LoginContext } from './loginContext';
import { notification } from 'antd';

const NotificacionContext = createContext();

export const NotificacionProvider = ({ children }) => {
  const { user } = useContext(LoginContext);
  const [socket, setSocket] = useState(null);
  const [notificaciones, setNotificaciones] = useState([]);

  useEffect(() => {
    if (!user || user.tiu_descripcion !== 'Cliente') {
      console.log('NotificacionContext: Usuario no es cliente o no está logueado', { user });
      return;
    }

    // Obtener clienteId
    const clienteId = user.cliente?.cli_id || user.cli_id;
    console.log('NotificacionContext: Intentando conectar con clienteId:', clienteId, 'User object:', user);

    if (!clienteId) {
      console.warn('NotificacionContext: No se encontró clienteId en el usuario');
      return;
    }

    // Conectar al servidor WebSocket
    // Socket.io se conecta al mismo servidor pero sin el path /api
    let socketUrl = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';
    // Remover /api del final si existe
    socketUrl = socketUrl.replace(/\/api\/?$/, '');
    // Si no tiene protocolo, agregar http://
    if (!socketUrl.startsWith('http')) {
      socketUrl = `http://${socketUrl}`;
    }
    
    console.log('NotificacionContext: Conectando a Socket.IO en:', socketUrl);
    
    const newSocket = io(socketUrl, {
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionAttempts: 5
    });

    newSocket.on('connect', () => {
      console.log('NotificacionContext: Conectado al servidor de notificaciones, socket.id:', newSocket.id);
      
      // Suscribirse a las notificaciones del cliente
      console.log('NotificacionContext: Suscribiendo cliente:', clienteId);
      newSocket.emit('subscribe', clienteId);
    });

    newSocket.on('connect_error', (error) => {
      console.error('NotificacionContext: Error de conexión:', error);
    });

    newSocket.on('disconnect', (reason) => {
      console.log('NotificacionContext: Desconectado del servidor de notificaciones, razón:', reason);
    });

    newSocket.on('notificacion', (data) => {
      console.log('NotificacionContext: Nueva notificación recibida:', data);
      
      // Agregar a la lista de notificaciones
      setNotificaciones(prev => [data, ...prev].slice(0, 50)); // Mantener solo las últimas 50

      // Mostrar notificación del navegador
      notification.open({
        message: 'Actualización de Pedido',
        description: data.mensaje || `Tu pedido #${data.pedidoId} cambió a: ${data.estadoNombre}`,
        duration: 5,
        placement: 'topRight',
        type: 'info',
        onClick: () => {
          // Opcional: navegar a la página de pedidos
          window.location.href = '/pedidos-cliente';
        }
      });

      // Intentar mostrar notificación push del navegador si está disponible
      if ('Notification' in window && Notification.permission === 'granted') {
        new Notification('Actualización de Pedido', {
          body: data.mensaje || `Tu pedido #${data.pedidoId} cambió a: ${data.estadoNombre}`,
          icon: '/logosuarez.png',
          badge: '/logosuarez.png',
          tag: `pedido-${data.pedidoId}`,
          requireInteraction: false
        });
      }
    });

    setSocket(newSocket);

    // Solicitar permiso para notificaciones del navegador
    if ('Notification' in window && Notification.permission === 'default') {
      Notification.requestPermission();
    }

    return () => {
      console.log('NotificacionContext: Cerrando conexión Socket.IO');
      newSocket.close();
    };
  }, [user]);

  const value = {
    socket,
    notificaciones,
    limpiarNotificaciones: () => setNotificaciones([])
  };

  return (
    <NotificacionContext.Provider value={value}>
      {children}
    </NotificacionContext.Provider>
  );
};

export const useNotificacion = () => {
  const context = useContext(NotificacionContext);
  if (!context) {
    // Retornar valores por defecto en lugar de lanzar error
    return {
      socket: null,
      notificaciones: [],
      limpiarNotificaciones: () => {}
    };
  }
  return context;
};
